import Box from '@mui/material/Box';
import theme from 'core/utilities/theme';
import React from 'react';

interface ComponentProps {
  line?: boolean;
}

function ButtonSeparator({ line }: ComponentProps) {
  if (line) {
    return (
      <Box sx={{
        ml: 1,
        mr: 1,
        mt: 0.5,
        width: '1px',
        height: theme.spacing(3),
        background: theme.palette.text.disabled,
      }}
      />
    );
  }

  return (
    <Box sx={{ ml: 1 }} />
  );
}

export default ButtonSeparator;
